<template>
  <div class="gene-panel-data-select-dailog dialog col-block">
    <div class="title-container row-block">
      <template v-if="data.data.length && functions['toggleData']">
        <div :style="{ width: '10px' }"></div>
        <img :src="data.data.filter(data => data.checked !== false).length ? data.data.filter(data => data.checked !== false).length === data.data.length ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-minus.svg') : require('../../assets/images/checkbox-false.svg')" @click="e => toggleData('all')">
        <div :style="{ width: '10px' }"></div>
      </template>
      <div class="title shrink">{{ data.name }}</div>
      <template v-if="data.data.some(data => data.checked === false)">
        <div :style="{ width: '10px' }"></div>
        <div class="sub">{{ '(' + data.data.filter(data => data.checked !== false).length + '/' + data.data.length + ')' }}</div>
      </template>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div v-if="data" class="data-container row-block flex-wrap flex-start" :class="{ 'only-line': data.data.length < 8 }" :style="{ flex: 1, 'max-height': Math.min(windowHeight - 321, 630) + 'px' }">
      <div class="data-block" v-for="(data, index) in data.data" :key="index" :style="{ width: '12.5%', height: '50px' }" @click="e => toggleData(index)">
        <div class="data row-block" :class="{ toggle: functions['toggleData'] }">
          <template v-if="functions['toggleData']">
            <img :src="data.checked !== false ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')">
            <div :style="{ width: '3px' }"></div>
          </template>
          <div class="data-content col-block" :style="{ flex: 1, width: 0 }">
            <div class="data-content-1 ellipsis" :title="data.symbol">{{ data.symbol }}</div>
            <div class="data-content-2" :title="data.gene_id">{{ '(' + data.gene_id + ')' }}</div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Return'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import responsitive from '../../mixins/responsitive'

export default {
  mixins: [
    responsitive
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      data: null
    }
  },
  created () {
    this.data = JSON.parse(JSON.stringify(this.param.data))
  },
  computed: {
    // param
    functions () {
      return this.param.functions || {}
    }
  },
  methods: {
    toggleData (index) {
      if (this.functions['toggleData']) {
        let result = this.functions['toggleData'](index)
        this.data = result
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/genePanelDataSelect.vue